import { Injectable } from '@angular/core';
import { ApplicationLogsRequest } from "leia-api";
import { AnnualIncome, Country, IncomeSource, Occupation } from "../model/models";
import { UtilitiesService } from "./utilities.service";

@Injectable({
  providedIn: 'root'
})
export class ApplicationLogMappingService {

  constructor(
    private utils: UtilitiesService
  ) { }

  mapEmploymentDetailsIdFieldsToDescriptions(
    request: ApplicationLogsRequest,
    countryList: Country[],
    annualIncomeList: AnnualIncome[],
    occupationList:  Occupation[],
    incomeSourceList: IncomeSource[]
  ): ApplicationLogsRequest {
    const mappedRequest: ApplicationLogsRequest = JSON.parse(JSON.stringify(this.utils.cloneObject(request)));

    mappedRequest.applicants?.forEach(applicant => {
      if (!!applicant.annualIncome && applicant.annualIncome.toString() !== "-1") {
        const annualIncome = annualIncomeList.find(
          record => record.annualIncomeId === Number(applicant.annualIncome)
        )!;
        applicant.annualIncome = `${annualIncome.annualIncomeId}|${annualIncome.displayValue}`;
      }

      if (!!applicant.employerCountry && applicant.employerCountry.toString() !== "-1") {
        const employerCountry = countryList.find(
          record => record.countryId === Number(applicant.employerCountry)
        )!;
        applicant.employerCountry = `${employerCountry.countryId}|${employerCountry.countryName}`;
      }

      const citizenship = (applicant as any).citizenship;
      if (!!citizenship && citizenship.toString() !== "-1") {
        const mappedCountryOfCitizenship = countryList.find(
          record => record.countryId === Number(citizenship)
        );

        if (mappedCountryOfCitizenship) {
          (applicant as any).citizenship =
            `${mappedCountryOfCitizenship.countryId}|${mappedCountryOfCitizenship.countryName}`;
        }
      }

      if (!!applicant.primarySourceOfFunds && applicant.primarySourceOfFunds.toString() !== "-1") {
        const primarySourceOfFunds = incomeSourceList.find(
          record => record.incomeSourceId === Number(applicant.primarySourceOfFunds)
        )!;
        applicant.primarySourceOfFunds = `${primarySourceOfFunds.incomeSourceId}|${primarySourceOfFunds.incomeSourceName}`;
      }

      if (!!applicant.occupation && applicant.occupation.toString() !== "-1") {
        const occupation = occupationList.find(
          record => record.occupationId === Number(applicant.occupation)
        )!;
        applicant.occupation = `${occupation.occupationId}|${occupation.occupationName}`;
      }
    });

    return mappedRequest;
  }
}
